import axios from 'axios';
import API_URL from './Backendurl';

export function isInsufficientNativeGasError(error) {
  const msg = [error?.shortMessage, error?.message, error?.reason, error?.data?.message]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
  const code = error?.code;
  return (
    code === 'INSUFFICIENT_FUNDS' ||
    msg.includes('insufficient funds') ||
    msg.includes('intrinsic transaction cost') ||
    msg.includes('gas required exceeds') ||
    msg.includes('fee') && msg.includes('insufficient')
  );
}

export async function requestGasDrip(walletAddress) {
  if (!walletAddress) return { funded: false, error: 'walletAddress is required' };
  try {
    const res = await axios.post(`${API_URL}/api/v1/relayer/gas-drip`, { walletAddress });
    return { funded: !!res.data?.funded, ...res.data };
  } catch (e) {
    return { funded: false, error: e?.response?.data?.error || e?.message || 'gas drip failed' };
  }
}

